export const getHeatmapPCount = (name, radius = 20) => {
  return {
    id: "7aq2l6",
    type: "heatmap",
    config: {
      dataId: "pcount",
      label: "heatmap",
      color: [119, 110, 87],
      highlightColor: [252, 242, 26, 255],
      columns: {
        lat: "lat",
        lng: "lon",
      },
      isVisible: true,
      visConfig: {
        opacity: 0.8,
        colorRange: {
          name: "ColorBrewer PuRd-6",
          type: "sequential",
          category: "ColorBrewer",
          colors: [
            "#fdd0a2",
            "#fdae6b",
            "#fd8d3c",
            "#e6550d",
            "#a63603"
          ],
        },
        radius: radius,
      },
      hidden: false,
      weightField: {
        name: name,
        type: "integer",
      },
      textLabel: [
        {
          field: null,
          color: [255, 255, 255],
          size: 18,
          offset: [0, 0],
          anchor: "start",
          alignment: "center",
        },
      ],
    },
    visualChannels: {
      weightField: {
        name: name,
        type: "integer",
      },
      weightScale: "linear",
    },
  }
}

export const getHeatmapPCountNorm = (name, radius = 25) => {
  return {
    id: "7aq2l6",
    type: "heatmap",
    config: {
      dataId: "pcount",
      label: name,
      color: [119, 110, 87],
      highlightColor: [252, 242, 26, 255],
      columns: {
        lat: "lat",
        lng: "lon",
      },
      isVisible: true,
      visConfig: {
        opacity: 0.8,
        colorRange: {
          name: "ColorBrewer PuRd-6",
          type: "sequential",
          category: "ColorBrewer",
          colors: [
            "#fdd0a2",
            "#fdae6b",
            "#fd8d3c",
            "#e6550d",
            "#a63603"
          ],
        },
        radius: radius,
      },
      hidden: false,
      weightField: {
        name: 'data_norm',
        type: "integer",
      },
      textLabel: [
        {
          field: null,
          color: [255, 255, 255],
          size: 18,
          offset: [0, 0],
          anchor: "start",
          alignment: "center",
        },
      ],
    },
    visualChannels: {
      weightField: {
        name: 'data_norm',
        type: "integer",
      },
      weightScale: "linear",
    },
  }
}